export const REPAIR_REQUEST_PRODUCT_UNMAPPED_LABEL = '無對照';

function trimPreviewText(value) {
  if (value == null) {
    return '';
  }
  return String(value).trim();
}

/** 已保存預覽：有代號或品名就顯示；兩欄皆空為「無對照」。 */
export function formatSavedRepairRequestProductLabel(line) {
  const parts = [trimPreviewText(line?.productCode), trimPreviewText(line?.itemName)]
    .filter(Boolean);
  if (parts.length === 0) {
    return REPAIR_REQUEST_PRODUCT_UNMAPPED_LABEL;
  }
  return parts.join(' · ');
}

/**
 * 編輯列標題。只有後端已回過預覽才顯示；新列不顯示「無對照」。
 * 預覽不啟用成立，成立仍只看草稿狀態。
 */
export function formatRepairRequestLineProductLabel(line) {
  if (line?.hasProductPreview !== true) {
    return '';
  }
  return formatSavedRepairRequestProductLabel(line);
}

export function createEmptyRepairRequestLine() {
  return {
    serialNo: '',
    problemDescription: '',
    accessories: '',
    salesDate: '',
    warrantyExpiryDate: '',
    remark: '',
    version: '',
    productCode: null,
    itemName: null,
    /** 僅 UI。新列尚未取得後端預覽。 */
    hasProductPreview: false,
  };
}

export function mapRepairRequestDetailToFormValues(detail) {
  return {
    repairRequestNo: detail?.repairRequestNo ?? '',
    repairRequestDate: detail?.repairRequestDate ?? '',
    remark: detail?.remark ?? '',
    /** 客戶關聯（customer_id）；聯絡人／地址仍為 UI 暫存。 */
    customerId: detail?.customerId ?? detail?.customer?.id ?? '',
    contactId: '',
    customerName: detail?.customerName ?? '',
    contactName: detail?.contactName ?? '',
    phone: detail?.phone ?? '',
    fax: detail?.fax ?? '',
    taxId: detail?.taxId ?? '',
    addressId: '',
    address: detail?.address ?? '',
    receivedDate: detail?.receivedDate ?? '',
    lines: (detail?.lines ?? []).map((line) => ({
      serialNo: line?.serialNo ?? '',
      problemDescription: line?.problemDescription ?? '',
      accessories: line?.accessories ?? '',
      salesDate: line?.salesDate ?? '',
      warrantyExpiryDate: line?.warrantyExpiryDate ?? '',
      remark: line?.remark ?? '',
      version: line?.version ?? '',
      mtrSnId: line?.mtrSnId ?? null,
      productCode: line?.productCode ?? null,
      itemName: line?.itemName ?? null,
      /** GET 回的是上次保存的預覽，不是即時重查。兩欄皆空也算已預覽。 */
      hasProductPreview: true,
      repairItemId: line?.repairItemId ?? line?.repairItem?.id ?? null,
    })),
  };
}

/**
 * Create／Update 寫入用 camel payload（API serialize 再轉 snake）。
 * Create 須帶 repairRequestNo；Update 不送單號；須帶 updatedAt；
 * customerId：Create 有選才送；Update 只在與載入值不同時送（清空＝null），
 * 避免既有關聯客戶已停用時 PATCH 被拒。
 * **不送** reservationId／contactId、productCode／itemName／hasProductPreview。
 */
export function buildRepairRequestWritePayload(values, {
  updatedAt = null,
  isEdit = false,
  originalCustomerId = '',
} = {}) {
  const customerId = values?.customerId || '';
  const payload = {
    repairRequestDate: values?.repairRequestDate || null,
    remark: values?.remark || null,
    customerName: values?.customerName || null,
    contactName: values?.contactName || null,
    phone: values?.phone || null,
    fax: values?.fax || null,
    taxId: values?.taxId || null,
    address: values?.address || null,
    receivedDate: values?.receivedDate || null,
    lines: (values?.lines ?? []).map((line) => ({
      serialNo: line?.serialNo ?? null,
      problemDescription: line?.problemDescription ?? null,
      accessories: line?.accessories || null,
      salesDate: line?.salesDate || null,
      warrantyExpiryDate: line?.warrantyExpiryDate || null,
      remark: line?.remark || null,
      version: line?.version || null,
    })),
  };

  if (!isEdit) {
    payload.repairRequestNo = values?.repairRequestNo || null;
    if (customerId) {
      payload.customerId = customerId;
    }
  } else if (customerId !== (originalCustomerId || '')) {
    payload.customerId = customerId || null;
  }

  if (updatedAt) {
    payload.updatedAt = updatedAt;
  }

  return payload;
}
